import React, { Fragment, useState, useRef, useEffect } from 'react'
import { jsonToFormData } from '../Basicos/funcoes';
import { Nav, TabContent, TabPane, Button, Form, FormGroup, Col, Row } from 'reactstrap';
import ModalHoc from "../Hoc/modalHoc"
import { Estruturas, NavItemCustom, Loader } from "../Basicos/index"
import { axiosApi } from '../Basicos/axiosInstances'
import { connect } from 'react-redux'
import * as actionsRedux from '../Store/Actions/index'
import ModalAtualizarAula from './ModalAtualizarAula';
// Dynamic import of ChaveamentoDeModal to avoid circular dependency
import Loadable from 'react-loadable';

const ChaveamentoDeModal = Loadable({
    loader: () => import('./ChaveamentoDeModal'),
    loading: () => <Loader overlay fixed />
});

const Modal = (props) => {
    const input = [];
    const [modalAtualizarHoje, setModalAtualizarHoje] = useState(false);
    const [periodosLetivos, setPeriodosLetivos] = useState([]);
    const [alocacoes, setAlocacoes] = useState([]);
    const [temVigenteAlocado, setTemVigenteAlocado] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [loader, setLoader] = useState(false);
    const formulario = useRef({});

    const [ativarModalSecundario, toggleModalSecundario] = useState(false);
    const [estruturaModalSecundario, setEstrutura] = useState();

    const [activeTab, setActiveTab] = useState(0);
    const {
        titulo,
        semSalvar,
        navs,
        blocos,
        estrutura,
        metodoRequisicao,
        requisicaoURL,
        contentType = 'application/json'
    } = props.data.modal;

    useEffect(() => {
        const buscarPeriodos = async () => {
            if (props.data.modal.titulo === "Editar Aula") {
                const aulaId = requisicaoURL.split('/').pop();
                if (aulaId && !isNaN(aulaId)) {
                    try {
                        const response = await axiosApi.get(`/aulas/${aulaId}/periodos-alocados`);
                        const periodos = response.data.dados || [];
                        const listaAlocacoes = response.data.alocacoes || [];
                        setPeriodosLetivos(periodos);
                        setAlocacoes(listaAlocacoes);
                        setTemVigenteAlocado(periodos.some(p => p.vigente));
                    } catch (error) {
                        console.error("Erro ao carregar periodos alocados:", error);
                    }
                }
            }
        };
        buscarPeriodos();
    }, [requisicaoURL, props.data.modal.titulo]);

    const buscarModalSecundario = async ({ url, metodo, params }) => {
        setLoader(true);
        try {
            const response = await axiosApi({
                method: metodo ? metodo : metodoRequisicao,
                url: url ? url : requisicaoURL,
                params: params
            });
            // console.log(response[0])
            // if (response[0] == 'professores')
            //     setEstrutura(response.data[2]);
            // else
            setEstrutura(response.data);
            toggleModalSecundario(true);
        } catch (error) {
            // console.log(error)
            props.ativar("receber", "erro");
        } finally {
            setLoader(false);
        }
    }

    const gerarEstruturaRef = (indiceNav = undefined) => {
        const estruturaRef = React.createRef();
        input.push({ indiceNav, estruturaRef });
        return estruturaRef;
    };

    const onChangeEstrutura = (formularioEstrutura) => {
        formulario.current = { ...formulario.current, ...formularioEstrutura };
    };

    const submitOnClick = async (atualizaHoje, confirmar = false, periodoLetivoId = null) => {
        const tipoDeAcao = metodoRequisicao === "put" ? "editar" : "adicionar";
        let formularioInvalido = false;
        let dados = {};
        try {
            for (let i = 0; i < input.length; i++) {
                const currentRef = input[i].estruturaRef.current;
                if (!currentRef) continue;

                const { state, formulario: dadosForm } = currentRef;
                if (state.incompleto && !confirmar) {
                    formularioInvalido = true;
                    if (input[i].indiceNav !== undefined) {
                        setActiveTab(input[i].indiceNav);
                    }
                    break;
                }
                Object.assign(dados, dadosForm);
            }

            // Se as refs sumiram mas já temos os dados no ref persistente (formulario.current)
            // ou se estamos confirmando, garantimos que 'dados' não esteja vazio
            if (Object.keys(dados).length === 0 && confirmar) {
                dados = { ...formulario.current };
            } else {
                formulario.current = { ...dados };
            }

            if (!formularioInvalido) {
                setLoader(true);
                if (props.data.modal.titulo == "Editar Aula") {
                    dados.atualizar_hoje = atualizaHoje ?? false;
                    dados.periodo_letivo_id = periodoLetivoId;
                    dados.professor_id_antes = props.estrutura.modal.navs[0].blocos[0].estrutura[8].valorPadrao.map(item => item.value);
                }
                try {
                    const requestData = contentType === 'multipart/form-data' ? jsonToFormData(dados, metodoRequisicao) : dados;
                    if (contentType === 'multipart/form-data') {
                        requestData.append('confirmar', confirmar);
                    } else {
                        requestData.confirmar = confirmar;
                    }

                    const response = await axiosApi({
                        method: contentType === 'multipart/form-data' ? 'POST' : metodoRequisicao,
                        url: requisicaoURL,
                        headers: { 'Content-Type': contentType },
                        data: requestData
                    });

                    if (response.data.requer_confirmacao) {
                        setLoader(false);
                        props.ativarModalConfirm({
                            titulo: "Confirmação de Local",
                            mensagem: response.data.aviso,
                            size: 'lg',
                            callback: () => submitOnClick(atualizaHoje, true)
                        });
                        return;
                    }

                    if (response.data.aviso) {
                        props.ativar(203, response.data.aviso);
                    }

                    if (response.data && response.data.sucesso) {
                        props.ativar(200, response.data.sucesso);
                    } else {
                        props.ativar(tipoDeAcao, "sucesso");
                    }

                    if (props[tipoDeAcao]) props[tipoDeAcao](response.data.model);
                    props.toggle();
                } catch (error) {
                    if (error.response && error.response.data.erro) {
                        props.ativar(error.response.status, error.response.data.erro)
                    } else {
                        props.ativar(tipoDeAcao, "erro");
                    }
                    props.toggle();
                }
            }
            setSubmit(true);
        } catch (error) {
            console.log(error);
        }
    };

    const gerarBlocos = (estruturas, indiceNav) => {
        return estruturas.map((elemento, indice) => {
            return <Estruturas
                estrutura={elemento.estrutura}
                buscarModalSecundario={buscarModalSecundario}
                ref={gerarEstruturaRef(indiceNav)}
                onChange={onChangeEstrutura}
                formularioGeral={formulario.current}
                tipo={"forms"}
                submit={submit}
                key={indice}
            />
        });
    };

    return (
        <Fragment>
            <Row noGutters className="menu-modal-formal">
                <Col sm={12} className="align-content-middle mb-2 mt-2">
                    <h4><b>{titulo}</b></h4>
                </Col>
                {navs && (
                    <Col sm={12} className="align-content-middle">
                        <Nav tabs className="">
                            {navs.map((elemento, indice) => {
                                return <NavItemCustom
                                    activeTab={activeTab}
                                    onClick={() => setActiveTab(indice)}
                                    descricao={elemento.label}
                                    id={indice}
                                    key={indice}
                                />
                            })}
                        </Nav>
                    </Col>
                )}
            </Row>
            <Form className="text-secondary">
                {navs && (
                    <Fragment>
                        {navs.map((elemento, indice) => {
                            return <TabContent activeTab={activeTab} key={indice}>
                                <TabPane tabId={indice}>
                                    <FormGroup row className="p-4">
                                        {gerarBlocos(elemento.blocos, indice)}
                                    </FormGroup>
                                </TabPane>
                            </TabContent>
                        })}
                    </Fragment>
                )}

                {blocos && (
                    <FormGroup row className="p-4">
                        {gerarBlocos(blocos)}
                    </FormGroup>
                )}

                {estrutura && (
                    <FormGroup row style={{ marginTop: 10 }} className="p-4">
                        <Estruturas
                            estrutura={estrutura}
                            buscarModalSecundario={buscarModalSecundario}
                            ref={gerarEstruturaRef()}
                            onChange={onChangeEstrutura}
                            formularioGeral={formulario.current}
                            tipo={"forms"}
                            submit={submit}
                        />
                    </FormGroup>
                )}
            </Form>
            <Col sm={12} className="align-content-middle mb-3 p-0">
                <Button onClick={props.toggle} className="float-right btn-transparente">{semSalvar ? "Sair" : "Cancelar"}</Button>
                {!semSalvar && <Button onClick={props.data.modal.titulo == "Editar Aula" ? props?.data?.modal?.navs?.[0].blocos?.[0].estrutura?.[4].valorPadrao?.value == 4 || props?.data?.modal?.navs?.[0].blocos?.[0].estrutura?.[4].valorPadrao?.value == 69 || props?.data?.modal?.navs?.[0].blocos?.[0].estrutura?.[4].valorPadrao?.value == 2 ? () => submitOnClick(false) : (temVigenteAlocado ? () => setModalAtualizarHoje(true) : () => submitOnClick(false)) : () => submitOnClick(false)} className="float-right">Salvar</Button>}
            </Col>
            {loader && <Loader overlay />}

            <ModalAtualizarAula isOpen={modalAtualizarHoje} atualizarAula={submitOnClick} periodosLetivos={periodosLetivos} alocacoes={alocacoes} />

            <ChaveamentoDeModal
                boolModal={ativarModalSecundario}
                toggle={() => toggleModalSecundario(!ativarModalSecundario)}
                estrutura={estruturaModalSecundario}
            />

        </Fragment>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
        desativar: () => dispatch(actionsRedux.desativarAlert()),
        ativarModalConfirm: (dados) => dispatch(actionsRedux.ativarModalConfirm(dados)),
    }
}

const ModalForm = ModalHoc(React.memo(Modal))
export default connect(null, mapDispatchToProps)(ModalForm)


